module.exports = __webpack_public_path__ + "static/media/img_19.ae3816b1.png";